import styled, { keyframes } from 'styled-components';
import { RalewayFont } from 'constants/fonts';

export const NarrativeStepStyled = styled.div`
  padding: 2rem;
  text-align: center;
`;

export const StepWidth = styled.div`
  width: 80rem;
  max-width: 100%;
  margin: 0 auto;

  ${props => (props.type === 'faces' ? `
    .face_bubble {
      opacity: 0.7;
      transition: all 0.3s ease;
      cursor: pointer;
      width: clamp(10rem, calc(25% - 2rem), 30rem);
      margin: 1rem;

      &.selected {
        opacity: 1;
        transform: scale(1.1);
      }
    }
  ` : '')}

  .carousel {
    height: auto;
  }
`;

const highlight = backgroundColorText => keyframes`
  from {
    background-image: none;
    background-repeat: no-repeat;
    background-position: left center;
    background-size: 0% 100%;
  }
  to {
    color: ${backgroundColorText};
    background-image: linear-gradient(#fff, #fff);
    background-repeat: no-repeat;
    background-position: left center;
    background-size: 100% 100%;
  }
`;

export const Title = styled.div`
  font-size: 2rem;
  color: #fff;
  text-align: center;
  margin-bottom: 2rem;
  line-height: 2.8rem;

  font-family: ${RalewayFont.semiBoldFamily};
  strong {
    ${RalewayFont.regularFamily}
    color: rgb(255, 255, 255);
    font-weight: 600;
    border-radius: 7px;
    padding-left: 8px;
    padding-right: 8px;
    white-space: nowrap;
    animation: 1s ease-out 0.5s 1 forwards ${props => highlight(props.color)};
  }
`;



// WEBPACK FOOTER //
// ./src/components/NarrativeStep/components/styles.js